import { getDpiStatuses } from '@/utils/api/config'
import { translations } from '@/utils/common'

export default {
  state: {
    dpiStatuses: {},
    dpiStatusesSelect: []
  },

  getters: {
    dpiStatuses(state) {
      return state.dpiStatuses
    },

    dpiStatusesSelect(state) {
      return state.dpiStatusesSelect
    }
  },

  actions: {
    initDpiStatuses({ commit }) {
      commit('dpiStatuses/update', getDpiStatuses())
    }
  },

  mutations: {
    'dpiStatuses/update'(state, payload) {
      // update dpiStatuses
      state.dpiStatuses = payload.reduce((map, es) => {
        map[es.value.toUpperCase()] = {
          ...es,
          text: translations[es.value.toLowerCase()]
        }
        return map
      }, {})

      // update dpiStatuses for select
      state.dpiStatusesSelect = payload.map(es => ({
        ...es,
        value: es.value.toUpperCase(),
        text: translations[es.value.toLowerCase()]
      }))
    }
  }
}
